import React, { createContext, useContext, useState } from "react";
import { IUserContext, IUserResponse } from "../exports/interfaces";

const UserContext = createContext<IUserContext>({
  user: null,
  setUser: () => {
    throw new Error("setUser not initialized");
  },
});
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<IUserResponse | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
